/**
 * UrbanFootprint App API
 * API for serving UrbanFootprint Application
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ClientResponse } from '../variables';

// @ts-ignore: This is used only for params, but some services have param-free APIs
import { MbiServiceInterface } from './mbi.serviceInterface';

// @ts-ignore: These imports are for both params and returnType, but we only use returnType
import { ProblemDetail } from '../model/problemDetail';

/**
 * Package: api
 */

const signUrlPrefix = `uf-api/mbi/sign_url/`;
/**
 * Action types for mbi.sign_url
 *
 * Sign a URL for the MBI API CloudFront distribution.
 */
export const signUrlActionTypes = {
  LOAD: `${signUrlPrefix}LOAD` as 'uf-api/mbi/sign_url/LOAD',
  SUCCESS: `${signUrlPrefix}SUCCESS` as 'uf-api/mbi/sign_url/SUCCESS',
  FAILURE: `${signUrlPrefix}FAILURE` as 'uf-api/mbi/sign_url/FAILURE',
  CLEAR: `${signUrlPrefix}CLEAR` as 'uf-api/mbi/sign_url/CLEAR',
} as const;

/**
 * LOAD action for mbi.sign_url
 * Sign a URL for the MBI API CloudFront distribution.
 */
export interface signUrlLoadAction {
  readonly type: 'uf-api/mbi/sign_url/LOAD';
  readonly params: MbiServiceInterface.signUrlParams;
  readonly promise: Promise<ClientResponse<string>>;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
  readonly key?: string;
}

/**
 * SUCCESS action for mbi.sign_url
 * Sign a URL for the MBI API CloudFront distribution.
 */
export interface signUrlSuccessAction {
  readonly type: 'uf-api/mbi/sign_url/SUCCESS';
  readonly result: string;
  readonly key?: string;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
}

/**
 * FAILURE action for mbi.sign_url
 * Sign a URL for the MBI API CloudFront distribution.
 */
export interface signUrlFailureAction {
  readonly type: 'uf-api/mbi/sign_url/FAILURE';
  readonly error: any;
  readonly key?: string;
  readonly requestId: string;
  readonly requestTime: string;
  readonly responseTime: string;
}

/**
 * CLEAR action for mbi.sign_url
 * Sign a URL for the MBI API CloudFront distribution.
 */
export interface signUrlClearAction {
  readonly type: 'uf-api/mbi/sign_url/CLEAR';
  readonly key: string;
}

export const mbiActionTypesMap = {
  /** Action types for mbi.sign_url */
  sign_url: signUrlActionTypes,
} as const;

export const mbiDetailsMap = {
  sign_url: {
    /** HTTP method for mbi.sign_url */
    httpMethod: 'post' as const,
  },
} as const;

/**
 * Local DataState<T> - kept in sync with uf/data/dataState.ts
 */
interface DataState<T> {
  readonly loading: boolean;
  readonly loaded: boolean;
  readonly requestId: string;
  readonly requestTime?: string;
  readonly responseTime?: string;
  readonly requestCount?: number;
  readonly error?: any;
  readonly promise?: Promise<T>;
  readonly data?: T;
  readonly extra?: any;
  readonly key?: string;
}
export interface MbiServiceState {
  /** all recent signUrl results (POST/PUT/PATCH) */
  readonly sign_url: DataState<string>[];
}
